import {
  Container,
  Stack,
  Spacer,
  Text,
  Button,
  Center,
  Box,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { shortString } from "../../utility/helper";
import Identicon from "react-identicons";
import { connectWallet } from "../../utility/Ether";
import { setWallet } from "../../Store/data";
import { ConnectWallet } from "../../utility/metamaskModal/connectWalletModal";
import { DrawerComponent } from "./drawer/drawer";

const InitialDrawerCompoent = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();

  return (
    <>
      <Button onClick={onOpen} ref={btnRef}> Menu</Button>
      <DrawerComponent
        isOpen={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        btnRef={btnRef}
      />
    </>
  );
};
const Header = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const address = useSelector((state) => {
    return state.userData.walletAddress;
  });
  return (
    <Box bg="#000">
      <Container>
        <Center>
          <Box>
            <Stack direction={"row"} align="center">
              <Stack
                padding={"15px"}
                direction={"row"}
                align={"center"}
                justify={"center"}
              >
                <Center gap={"10px"}>
                  <InitialDrawerCompoent/>
                  <Button variant={"nav"}>Home</Button>
                  <Button variant={"nav"}>Create Event</Button>{" "}
                  {/* <Button variant={"nav"}>About</Button> */}
                  {/* <Spacer /> */}
                </Center>
              </Stack>
              <Box alignItems={"flex-end"}>
                <Button
                  onClick={onOpen}
                  leftIcon={
                    <Box borderRadius={"full"} overflow="hidden">
                      <Identicon
                        size="25"
                        bg="#fff"
                        borderRadius="999px"
                        string={address}
                      />
                    </Box>
                  }
                  size={"sm"}
                  variant={"wallet"}
                >
                  {address ? shortString(address, 14) : "Connect Wallet"}
                </Button>
                {ConnectWallet({ isOpen, onOpen, onClose })}
              </Box>
            </Stack>
          </Box>
        </Center>
      </Container>
    </Box>
  );
};

export default Header;
